module.exports = function() {
  return new Worker(__webpack_public_path__ + "fdaaeb9ee74d118e10e8.worker.js");
};